import React from 'react'

class InventoryDetailGrid {

  constructor(inventoryId, params) {
    this.inventoryId = inventoryId
    this.endpoint = `inventory/v1/inventories/${inventoryId}/items/by-products-types?${params || ''}`
    this.defaultSort = 'productType.reference'
  }

  columns = [
    {
      Header: 'Referência',
      accessor: 'productType.reference',
      Cell: ({ original }) => (
        original.productType && original.productType.reference &&
        <a href={`#/inventories/${this.inventoryId}/items?productType=${original.productType && original.productType.id}`}>
          {original.productType.reference}
        </a>
        || 'Sem dados'
      )
    },
    {
      Header: 'Nome',
      accessor: 'productType.friendlyName'
    },
    {
      Header: 'Total esperados',
      accessor: 'totalExpected',
      sortable: false,
      Cell: ({ original }) => original.totalNotFound + original.totalFound || 0
    },
    {
      Header: 'Total não esperados',
      accessor: 'totalUnexpected',
      Cell: ({ original }) => original.totalUnexpected || 0
    },
    {
      Header: 'Total encontrados',
      accessor: 'totalFound',
      Cell: ({ original }) => original.totalFound || 0
    },
    {
      Header: 'Total não encontrados',
      accessor: 'totalNotFound',
      Cell: ({ original }) => original.totalNotFound || 0
    },
    {
      Header: 'Total lidos',
      accessor: 'total',
      sortable: false,
      Cell: ({ original }) => original.totalFound + original.totalUnexpected || 0
    },
  ];

}

export default InventoryDetailGrid;



// WEBPACK FOOTER //
// ./src/customGrid/entities/InventoryDetailGrid.js